import {
  FC,
  createContext,
  Dispatch,
  PropsWithChildren,
  RefObject,
  SetStateAction,
  useContext,
  useRef,
  useState,
} from 'react';

type CollectionContextType = {
  videoRef: RefObject<HTMLVideoElement> | null;
  isPause: boolean;
  setIsPause: Dispatch<SetStateAction<boolean>>;
  handlePause: () => void;
};

const CollectionContext = createContext<CollectionContextType | null>(null);

const CollectionProvider: FC<PropsWithChildren> = ({ children }) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [isPause, setIsPause] = useState(true);

  const handlePause = () => {
    if (!videoRef.current) return;

    if (!videoRef.current.paused) {
      videoRef.current.pause();
      setIsPause(true);
    } else {
      videoRef.current.play();
      setIsPause(false);
    }
  };

  return (
    <CollectionContext.Provider value={{ videoRef, isPause, setIsPause, handlePause }}>
      {children}
    </CollectionContext.Provider>
  );
};

export const useCollection = () => {
  const context = useContext(CollectionContext);

  if (!context) {
    throw new Error('useCollection must be used within a CollectionProvider');
  }

  return context;
};

export default CollectionProvider;
